import { Grid, Typography } from '@mui/material';
import {
  getUsersWithFilters,
  PermissionsEnum,
  ProcureUser,
  Property,
} from 'vendor-marketplace-shared-library';
import { UserDetailsModule } from '../../../components/common/UserDetailsModule';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { DropdownWithCheckboxes } from '../../../components/common/DropdownWithCheckboxes';
import UserService from '../../../services/user.service';
import PrimaryButton from '../../../components/common/styled-mui-overrides/PrimaryButton';
import useAuth from '../../../hooks/useAuth';

export default function PropertyUsersModule(props: { property: Property }) {
  const { validateUserPermissions } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);
  const { data: usersData, refetch } = useQuery(getUsersWithFilters, {
    variables: { propertyIds: [Number(props.property.id)] },
    onCompleted: data => {
      setSelectedUserIds(data.getUsersWithFilters.map((user: ProcureUser) => user.id));
    },
  });

  const { data: organizationUsersData } = useQuery(getUsersWithFilters);

  const addUsersToProperty = async () => {
    await UserService.setUsersOnProperty(
      Number(props.property.id),
      selectedUserIds.map(id => Number(id)),
    );
    refetch();
  };

  return (
    <Grid container rowGap={2} boxShadow={2} sx={styles.userContainer}>
      <Grid item container sx={styles.subContainer}>
        <Grid item>
          <Typography variant={'h6'}>Team</Typography>
        </Grid>
        {validateUserPermissions([PermissionsEnum.PROPERTY_USERS_UPDATE]) && (
          <Grid item>
            <PrimaryButton
              onClick={(e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)}
            >
              Change selection
            </PrimaryButton>
          </Grid>
        )}
      </Grid>
      <Grid item container spacing={2}>
        {usersData?.getUsersWithFilters.map((user: ProcureUser) => (
          <Grid item key={user.id} xs={12}>
            <UserDetailsModule user={user} />
          </Grid>
        ))}
      </Grid>

      <DropdownWithCheckboxes
        entities={
          organizationUsersData?.getUsersWithFilters.map((user: ProcureUser) => {
            return { ...user, userRoleName: user.userRole?.name };
          }) ?? []
        }
        onClose={() => {
          setAnchorEl(null);
          addUsersToProperty();
        }}
        onSave={() => {}}
        anchorEl={anchorEl}
        selectedIds={selectedUserIds ?? []}
        setSelectedIds={setSelectedUserIds}
        isDisabled={entity => entity.userRole?.name === 'Admin'}
        displayFieldKey={'fullName'}
        subtextFieldKey={'userRoleName'}
      />
    </Grid>
  );
}

const styles = {
  userContainer: {
    overflow: 'auto',
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'secondary.light',
    flexDirection: 'column',
  },
  subContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
